import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import { AlertWarn } from "../component/common/Alert"

export function MbrSelect() {
    const [checkedMbrTerms, setCheckedMbrTerms] = useState(false);
    const [checkedPrivateTerms, setCheckedPrivateTerms] = useState(false);
    const [checkedWholeTerms, setCheckedWholeTerms] = useState(false);
    
    const [showAlertWarn, setShowAlertWarn] = useState(false);
    const [alertWarnMessage, setAlertWarnMessage] = useState("회원가입약관과 개인정보방침안내에 동의해주셔야 가입이 가능합니다.");
   

    let navigate = useNavigate(); 
    function clickMbrCpReg() {
        if(isValidTerms()){
            let url = "/mbr_cp_reg";
            navigate(url);
        } else {
            setShowAlertWarn(true)
        }
    }

    function clickMbrPvReg() {
        if(isValidTerms()){
            let url = "/mbr_pv_reg";
            navigate(url);
        } else {
            setShowAlertWarn(true)
        }
    }

    function isValidTerms(){
        return checkedMbrTerms && checkedPrivateTerms
    }

    function clickMbrTermsCheckbox() {
        setShowAlertWarn(false)
        if(checkedMbrTerms){
            setCheckedMbrTerms(false);
        } else {
            setCheckedMbrTerms(true);
        }
        
    }

    function clickPrivateTermsCheckbox() {
        setShowAlertWarn(false)
        if(checkedPrivateTerms){
            setCheckedPrivateTerms(false);
        } else {
            setCheckedPrivateTerms(true);
        }
    }

    function clickWholeTermsCheckbox() {
        setShowAlertWarn(false)
        if(checkedWholeTerms){
            setCheckedWholeTerms(false);
            setCheckedMbrTerms(false);
            setCheckedPrivateTerms(false);
        } else {
            setCheckedWholeTerms(true);
            setCheckedMbrTerms(true);
            setCheckedPrivateTerms(true);
        }
    }

    return (
        <div>
            <main class="page lanidng-page">
                <section class="py-4 py-xl-5">
                    <div class="container py-4 py-xl-5" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <div class="row mb-5">
                            <div class="col-md-8 col-xl-6 text-center mx-auto">
                                <h2 style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>회원가입</h2>
                            </div>
                        </div>
                    </div>
                    
                    <div class="container">
                        <div class="row">
                            <div class="col">
                                <section class="position-relative py-4 py-xl-5">
                                    <div class="container position-relative" style={{borderColor: 'var(--bs-emphasis-color)'}}>
                                        <div class="card mb-5">
                                            <div class="card-body p-sm-5">
                                                <h2 class="text-center mb-4" style={{fontSize: '26px', fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>회원가입약관</h2>
                                                <form method="post">
                                                    <div class="mb-3">
                                                        <p style={{fontFamily: 'Nanum Gothic', borderRadius: '5px', border: '1px solid var(--bs-body-color)'}}><br/>* 온라인 구인구직 사이트 운영회사인 "지쿠(GKoo)"는 “당사”로 표기됩니다.<br/><br/>* 정보통신 단말기(컴퓨터, 휴대폰, TV등...)로 접속이 가능한 가상의 영업/마케팅장소와&nbsp;인터넷 홈페이지는 “사이트”로 표기됩니다.<br/>* "당사"가 운영하는 온라인 구인구직 등의"사이트"를 “당 사이트”로 표기합니다. 하나의 통합된 "아이디", "비밀번호"로 "당 사이트"를 이용할 수 있습니다.<br/>* 마우스 클릭(선택버튼 누름)에 의해 인터넷상으로 연결되어있는 상태를 “링크”로 표기합니다.<br/>* "당 사이트”에 등록된 "링크"를 포함한 모든 내용은 “자료”로 표기됩니다. 자료 예: 회원정보, 증명서, 사진/이미지, 각종광고 및 이력서, 각종 데이터, 매매정보, 답글/꼬릿말, 홍보물 또는 클릭시 타 "사이트"로 이동되는 "링크" 등등 (이하 “아이디” 또는 "ID"로 표기)를 부여받은 사람(또는 회사/단체)을 “회원”으로 표기합니다. "회원"은 일반회원, 정회원, 기업회원, 개인 또는 구직회원, 선생님회원, 학생(학부모)회원, 유료회원, 무료회원등으로 구분될 수 있습니다.<br/>* "회원"을 포함한 모든 "당 사이트" 방문객을 “이용자”라 표기합니다.<br/>* "비밀번호" 또는 "패스워드"는 본인 확인을 위해 "이용자"가 지정한 영문과 숫자의 조합을 뜻합니다.<br/>제1조 (목적)<br/>&nbsp; 본 약관은 “당사”가 인터넷 또는 정보통신망을 통해 제공하는 “당 사이트”에 "자료"등록, "자료"조회, "자료"이용, 구입 또는 판매를 목적으로 하는 모든 "이용자"에 대해 “당 사이트” 이용방법과 조건 규정을 목적으로 합니다.<br/><br/></p>
                                                    </div>
                                                    <div><label class="form-label" style={{paddingRight: '10px', fontWeight: 'bold'}}>회원가입약관의 내용에 동의합니다.</label>
                                                        <input type="checkbox" checked={checkedMbrTerms} onChange={clickMbrTermsCheckbox}/></div>
                                                </form>
                                            </div>
                                        </div>
                                        <div class="card mb-5">
                                            <div class="card-body p-sm-5">
                                                <h2 class="text-center mb-4" style={{fontSize: '26px', fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>개인정보처리방침안내</h2>
                                                <form method="post">
                                                    <div class="mb-3">
                                                        <div class="table-responsive" style={{border: '1px solid var(--bs-table-border-color)', fontFamily: 'Nanum Gothic'}}>
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>목적</th>
                                                                        <th>항목</th>
                                                                        <th>보유기간</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>이용자 식별 및 본인여부 확인</td>
                                                                        <td>아이디, 이름, 비밀번호</td>
                                                                        <td>회원 탈퇴시까지</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>고객서비스 이용에 관한 통지,<br/>CS 대응을 위한 이용자 식별</td>
                                                                        <td>연락처(이메일, 휴대전호번호)</td>
                                                                        <td>회원 탈퇴시까지</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div><label class="form-label" style={{paddingRight:'10px', fontWeight: 'bold'}}>개인정보처리방침안내의 내용에 동의합니다.</label>
                                                        <input type="checkbox" checked={checkedPrivateTerms} onChange={clickPrivateTermsCheckbox}/></div>
                                                </form>
                                            </div>
                                        </div>
                                        <div class="card mb-5" style={{borderStyle: 'hidden'}}>
                                            <div style={{textAlign:'center', borderStyle:'hidden'}}><label class="form-label" style={{paddingRight:'10px', fontWeight:'bold'}}>전체선택</label>
                                                <input type="checkbox" checked={checkedWholeTerms} onChange={clickWholeTermsCheckbox}/></div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <AlertWarn show={showAlertWarn} msg={alertWarnMessage} />
                        </div>
                    </div>
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6 d-md-flex justify-content-md-end align-items-md-center justify-content-lg-end">
                                <div class="card d-flex d-sm-flex justify-content-center align-items-center justify-content-sm-center align-items-sm-center">
                                    <div class="card-body d-flex d-sm-flex d-md-flex d-lg-flex justify-content-center align-items-center justify-content-sm-center align-items-sm-center justify-content-md-center align-items-md-center justify-content-lg-center align-items-lg-center" style={{width: '300px', height: '100px'}}>
                                        <button class="btn d-block w-100" type="submit" style={{fontWeight: 'bold'}} onClick={clickMbrCpReg}>기업회원</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 d-md-flex justify-content-md-start justify-content-lg-start">
                                <div class="card d-flex d-sm-flex justify-content-center align-items-center justify-content-sm-center align-items-sm-center">
                                    <div class="card-body d-flex d-sm-flex d-md-flex d-lg-flex justify-content-center align-items-center justify-content-sm-center align-items-sm-center justify-content-md-center align-items-md-center justify-content-lg-center align-items-lg-center" style={{width: '300px', height: '100px'}}>
                                        <button class="btn d-block w-100" type="submit" style={{fontWeight: 'bold'}} onClick={clickMbrPvReg}>개인회원</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    
                </section>
            </main>
        </div>
        
    );
}